import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "cfpv_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const api = axios.create({ baseURL: `${BACKEND}/api` });
api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "Bir hata oluştu, lütfen tekrar deneyin") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) {
    const first = d[0];
    const field = first.loc?.[first.loc.length - 1];
    return `Geçersiz alan${field ? ` (${field})` : ""}: ${first.msg}`;
  }
  return fallback;
}

export const fileUrl = (u) => (!u ? null : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const formatPrice = (price, currency = "TRY") =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 0 }).format(price);

export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" }) : "");

export function specDisplay(field, value) {
  if (value === undefined || value === null || value === "" || (Array.isArray(value) && !value.length)) return null;
  if (field?.type === "boolean") return value ? "Evet" : "Hayır";
  if (Array.isArray(value)) return value.join(", ");
  return field?.unit ? `${value} ${field.unit}` : String(value);
}
